import {
  client,
  getServiceHeaders,
  getServiceUrl,
  handleClientError,
  getAccessToken,
  ResponseCallback
} from '.'

/**
 *
 * @param path path to endpoint (e.g. /users/)
 * @param reqAuth boolean if request requires authentication
 * @param body Body of type I (can be any input)
 * @returns promise ServiceResponse <R>
 */
export const put = async <I, O>({
  path,
  body,
  token = getAccessToken(),
  headers,
  respCb
}: {
  path: string
  body: I
  token?: string
  headers?: HeadersInit,
  respCb?: ResponseCallback<O>
}): Promise<O> => {
  try {
    return client<I, O>({
      url: getServiceUrl(path),
      method: 'PUT',
      headers: getServiceHeaders(token, headers),
      body,
      respCb
    })
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (e: any) {
    throw handleClientError(e)
  }
}
